// src/sim/lighting/constants.ts — P2 lighting tunable constants (VIS-05, VIS-06, VIS-07, VIS-08).
//
// Invariants:
//   - No side effects; module-level numeric constants only.
//   - Every value is tick-count-based or tile-based (no milliseconds; no pixels).
//   - Mark P7-tunable values with `// TODO(P7): retune from playtest`.
//
// Source: .planning/phases/02-fov-lighting/02-CONTEXT.md D-05..D-08.

/** Motion light stay-on duration: 4 s @ 30 Hz = 120 ticks. D-05. */
export const P2_MOTION_LIGHT_STAY_TICKS = 120;

/** Motion light fade duration: 400 ms @ 30 Hz = 12 ticks. D-05. */
export const P2_MOTION_LIGHT_FADE_TICKS = 12;

/** Torch cone radius in TILES. 8 tiles ≈ 256 px reach. D-06. TODO(P7): retune from playtest. */
export const P2_TORCH_RADIUS_TILES = 8;

/** Torch cone half-angle in radians. Pi/6 = 30° so full cone = 60°. D-06. TODO(P7): retune from playtest. */
export const P2_TORCH_HALF_ANGLE_RAD = Math.PI / 6;

/** Dark-is-slower speed floor: speed multiplier at light=0. D-08. TODO(P7): retune from playtest. */
export const P2_DARK_SPEED_FLOOR = 0.6;

/** Torch contribution to lightLevelAt for a tile inside the torch FOV. D-06. TODO(P7): retune from playtest. */
export const P2_TORCH_LIGHT_CONTRIBUTION = 0.6;

/** Default permanent light radius when unset by authoring. Tiles. D-02/D-07. */
export const P2_DEFAULT_LIGHT_RADIUS_TILES = 5;
